module.exports = __webpack_public_path__ + "img/1143630.jpg";